import CommonDataProtection from '@/modules/common/hiring/models/MID/CommonDataProtection'
import PetsPolicyHolderToSave from '../PetsPolicyHolderToSave'

export default class PetsSavePolicyHolderRequest {
  /** (UUID): Identificador único de la cotización. Ejemplo: 23423-643hbf-74834hj. */
  quotationId!: string

  /** Información del titular de la póliza. */
  policyHolder!: PetsPolicyHolderToSave

  /** Objeto que contiene información sobre protección de datos. */
  dataProtection!: CommonDataProtection

  constructor(data: any) {
    this.quotationId = data.quotationId

    if (data.policyHolder) {
      this.policyHolder = new PetsPolicyHolderToSave(data.policyHolder)
    }

    if (data.dataProtection) {
      this.dataProtection = new CommonDataProtection(data.dataProtection)
    }
  }
}
